import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from "vue";
import { useUserStore } from "@/stores/userStore";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UserActivityBarSettings',
    setup(__props) {
        const userStore = useUserStore();
        const show = ref(false);
        const enableActivityBar = computed({
            get: () => {
                return userStore.showActivityBar;
            },
            set: () => {
                // always toggle tool side panel when enabling activity bar
                if (userStore.toggledSideBar !== "tools") {
                    userStore.toggleSideBar("tools");
                }
                // toggle activity bar
                userStore.toggleActivityBar();
            },
        });
        return { __sfc: true, userStore, show, enableActivityBar };
    }
});
